// extracted by mini-css-extract-plugin
export var boldLabel = "FooterLink-module--bold-label--32bd0";